import { MenuAccess } from './types';
import { AppSetting } from 'dependencies/appsettings';
import { ShellState, AuthState, AccessInfoData, AdminInfoData } from 'app/types-shared';
import { getExternalUserHandlingPolicyCheckLink, isExternalUserHandlingEnabled } from 'app/infrastructure/hosting';

export function userInfoNotLoaded(state: ShellState) {
  return state.authState === AuthState.Authenticated && !state.fetching && (!state.userInfo || !state.userInfo.id);
}

export function userIsLoggedIn(state: ShellState) {
  return state.authState === AuthState.Authenticated && state.userInfo && state.userInfo.id;
}

export const shouldCheckExternalUserHandlingPolicy = () => 
  isExternalUserHandlingEnabled() && !!getExternalUserHandlingPolicyCheckLink();

export const externalUserHandlingPolicyIsAccepted = (state: ShellState) => 
  shouldCheckExternalUserHandlingPolicy() ? state.isExternalUserHandlingPolicyAccepted : true;

export const getMenuAccess = (accessData: AccessInfoData): MenuAccess => ({
  codetableAdministration: !!(AppSetting.AdminApiBaseUrl && accessData && accessData.adminPanel &&
    (accessData.adminPanel as AdminInfoData).codetable && (accessData.adminPanel as AdminInfoData).codetable.read),

  userAdministration: !!(AppSetting.AdminApiBaseUrl && accessData && accessData.adminPanel &&
    (accessData.adminPanel as AdminInfoData).user && (accessData.adminPanel as AdminInfoData).user.read),

  roleAdministration: !!(AppSetting.AdminApiBaseUrl && accessData && accessData.adminPanel &&
    (accessData.adminPanel as AdminInfoData).role && (accessData.adminPanel as AdminInfoData).role.read),

  dashboardAdministration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.dashboard?.administrationCentral),

  companyReportAdministration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.companyReport?.administrationCentral),

  favouriteAdministration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.favourite?.administrationCentral),

  messageAdministration: !!(AppSetting.AdminApiBaseUrl && accessData && accessData.adminPanel &&
    (accessData.adminPanel as AdminInfoData).message && (accessData.adminPanel as AdminInfoData).message.read),

  textConfiguration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.translation?.administrationCentral),

  importSetsAdministration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.interfaceAdministration?.administrationCentral),

  externalUrlAdministration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.externalUrl?.administrationCentral),

  subscriberGroupAdministration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.subscriberGroup?.administrationCentral),

  experienceTransferAdministration: !!(AppSetting.AdminApiBaseUrl && accessData?.adminPanel?.experienceTransfer?.administrationCentral),

  refreshCache: accessData && accessData.tools && accessData.tools.refreshCache,
  imports: accessData && accessData.tools && accessData.tools.exportAndImport && accessData.tools.exportAndImport.import,
  regenerateAggregatedData: accessData && accessData.tools && accessData.tools.regenerateAggregatedData,
  manageSurveys: accessData && accessData.surveyManager && accessData.surveyManager.edit
});
